module.exports = __webpack_public_path__ + "static/media/bff10.12ba9c42.png";